import React, { useState, useRef, useEffect } from 'react'
// import PropTypes from 'prop-types'
import styled from 'styled-components';
import useFiles from './useFiles';
import { transparentize, darken } from 'polished'

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
`
const LabelTxt = styled.span`
  font-family: OpenSansRegular;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  letter-spacing: -0.01em;
  color: #333333;
`
const HelperTxt = styled.span`
  font-family: OpenSansRegular;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.005em;
  color: #CCCCCC;
  margin-left: .5em;
`
const UploadContainer = styled.div`
  width: 100%;
  height: 10em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  margin: 1em auto;
  border: 1px solid #EFEFEF;
  box-sizing: border-box;
  border-radius: 10px;
  transition: 0.2s box-shadow, 0.2s background-color;
  box-shadow: ${({over}) => over ? '0 20px 60px -30px rgba(#2669ff, 1)' : '0 10px 40px -30px rgba(black, 0.2)'};
  /* background-color: ${({over}) => over ? '#F2F4F9' : '#F2F4F9'}; */
  background-color: ${({over}) => over ? '#F9F9F9' : '#F9F9F9'};
`
const SubTitle = styled.h2`
  color: ${({over, loaded}) =>
    over
    ? '#58595B'
    : loaded
      ? '#58595B'
      : '#CCCCCC'
  };
  transition: 0.2s color;
  font-family: OpenSansRegular;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 23px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: -0.01em;
`
const ButtonInput = styled.div`
  width: 250px;
  height: 46px;
  background: ${({loaded}) => loaded ? '#F9F9F9' : '#9240C9'};
  border: ${({loaded}) => loaded ? '2px solid #9240C9': 'none'};
  cursor: pointer;
  margin-top: 2em;
  /* Sombras / Principal */
  box-shadow: ${({loaded}) =>
    loaded
    ? '0px 3px 6px rgba(146, 64, 201, 0.12), 0px 0px 1px rgba(146, 64, 201, 0.2)'
    : '0px 2px 4px rgba(146, 64, 201, 0.15)'
  };
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align:center;
  transition: background 200ms ease-in-out;
  &:hover{
    background: ${({loaded}) => loaded ? transparentize(0.8, '#9240C9') : darken(0.1, '#9240C9')}
  }
`
const ButtonTxt = styled.span`
  font-family: OpenSansRegular;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.035em;
  text-transform: uppercase;
  color: ${({loaded}) => loaded ? '#9240C9' : '#ffff'};
`

const InputDrag = ({ onDrop, maxFiles = 1, value }) => {

  const [over, setover] = useState(false);
  const [files, setfiles] = useFiles({ maxFiles });
  const $input = useRef(null);

  useEffect(() => {
    // if (onDrop) {
    //   onDrop(files);
    // }
    if(!value){
      setfiles([])
    }
  // eslint-disable-next-line
  }, [value]);

  const formatNameFile = ({ name, size }) => {
    const newName = `${name.replace(/ /g, '_')} (${(size/1000).toFixed()} kb)`
    return newName
  }

  return (
    <div>
      <LabelContainer>
        <LabelTxt>Cargar archivo Excel</LabelTxt>
        <HelperTxt>(En formato .xls o .xlsx)</HelperTxt>
      </LabelContainer>
      <UploadContainer
        onDrop={e => {
          e.preventDefault();
          e.persist();
          setfiles(e.dataTransfer.files);
          onDrop(e.dataTransfer.files);
          setover(false);
        }}
        onDragOver={e => {
          e.preventDefault();
          setover(true);
        }}
        onDragLeave={e => {
          e.preventDefault();
          setover(false);
        }}
        over={over}
      >
        <SubTitle
        over={over}
        loaded={files.length>0 ? true : false}>
          {
            over
              ? 'Suelte el archivo'
              : files.length>0
                ? formatNameFile(files[0])
                : 'Suba o arrastre documentos aqui'
          }
        </SubTitle>
        <ButtonInput
          onClick={() => {
            $input.current.click();
          }}
          loaded={files.length>0 ? true : false}
        >
          <ButtonTxt loaded={files.length>0 ? true : false}>
            {files.length>0 ? 'Reemplazar archivo' : 'Subir desde mi equipo'}
          </ButtonTxt>
          <input
            style={{ display: "none" }}
            type="file"
            // accept="image/*"
            ref={$input}
            onChange={e => {
              setfiles(e.target.files);
              onDrop(e.target.files)
            }}
            multiple={maxFiles > 1}
          />
        </ButtonInput>
      </UploadContainer>
    </div>
  )
}

InputDrag.propTypes = {

}

export default InputDrag
